export interface IAreaItem {
    id: string;
    areaName: string;
}

export interface IAreaState {
    provinceId: string;
    provinceName: string;
    cityId: string;
    cityName: string;
    districtId: string;
    districtName: string;
    provinces: IAreaItem[];
    citys: IAreaItem[];
    districts: IAreaItem[];
}

enum AREA_TYPE {
    PROVINCE_TYPE = 1,
    CITY_TYPE = 2,
    DISTRICT_TYPE = 3
}

export default AREA_TYPE;